export default {
  buildCosts: {
    groundWorks: 'Ground Works',
    construction: 'Construction',
    landscaping: 'Landscaping',
    contingency: 'Contingency'
  },
  financeCosts: {
    lendingFees: 'Lending Fees',
    interestProvision: 'Interest Provision',
    legalFees: 'Legal Fees',
    valuationFees: 'Valuation Fees',
    other: 'Other Fees'
  },
  otherCosts: {
    section106Cil: 'Section 106/CIL'
  },
  professionalCosts: {
    projectManagement: 'Project Management',
    warrantyCosts: 'Warranty Costs',
    architectFees: 'Architect Fees',
    monitoringSurveyors: 'Monitoring Surveyors'
  },
  salesCosts: {
    agencyFee: 'Agency Fee',
    marketingMaterial: 'Marketing Material',
    dressings: 'Dressings',
    saleLegalCosts: 'Sale Legal Costs'
  },
  siteCosts: {
    purchasePrice: 'Purchase Price',
    stampDuty: 'Stamp Duty',
    legalFees: 'Legal Fees',
    introducerCommission: 'Introducer Commission'
  }
}
